import styled from "@emotion/styled";

export const BannerRoot = styled.div`
  padding: 0.75rem;
  border-radius: 6px;
  color: var(--mb-color-text-medium);
  background-color: var(--mb-color-bg-light);
`;
